export default function (existingData = {}) {
  return {
    initiator: null,
    companyRef: null,
    commission: 0,
    buyerCommission: 0,
    itemsReleasePeriod: '2 Weeks',
    termsAgreed: 0,
    listingRef: null,
    bidRef: null,
    total: null,
    items: [
      {
        quantity: null,
        description: '',
        unitPrice: null,
        tax: 0
      }
    ],
    currencyCode: 'GBP',
    seller: {
      ...existingData.seller
    },
    buyer: {
      ...existingData.buyer
    },
    isBuyer: false,
    ...existingData
  }
}
